import { render, staticRenderFns } from "./RechargeList.vue?vue&type=template&id=0b3cffa0&scoped=true&"
import script from "./RechargeList.vue?vue&type=script&lang=js&"
export * from "./RechargeList.vue?vue&type=script&lang=js&"
import style0 from "./RechargeList.vue?vue&type=style&index=0&id=0b3cffa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3cffa0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VForm,VTextarea})
